import axios from 'axios';

export class BreakLoanService {

    breakLoan(loanId) {
        return axios.post('/appapv/breakLoan.action', {}, {
            params: {
                folio: loanId,
            }
        }).then(res => res.data);
    }

    settleBrokenLoan(loanId) {
        return axios.post('/appapv/settleBreakLoan.action', {}, {
            params: {
                folio: loanId,
            }
        }).then(res => res.data);
    }

    cancelBrokenLoan(loanId, message) {
        return axios.post('/appapv/cancelBreakLoan.action', {}, {
            params: {
                folio: loanId,
                mensaje: message
            }
        }).then(res => res.data);
    }
}